import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntegerDirective } from 'src/app/directives/integer.directive';
import { MaskDirective } from 'src/app/directives/mask.directive';
import { PhoneMaskDirective } from 'src/app/directives/phone-mask.directive';
import { ServicoObservacoesFormatDirective } from 'src/app/directives/servico-observacoes-format.directive';
import { TypeWriteDirective } from 'src/app/directives/type-write.directive';
import { UppercaseDirective } from 'src/app/directives/uppercase.directive';
import { Bg2Directive } from 'src/app/directives/bg-2.directive';
import { Bg1Directive } from 'src/app/directives/bg-1.directive';

@NgModule({
  declarations: [
    IntegerDirective,
    MaskDirective,
    PhoneMaskDirective,
    ServicoObservacoesFormatDirective,
    TypeWriteDirective,
    UppercaseDirective,
    Bg1Directive,
    Bg2Directive
  ],
  exports: [
    IntegerDirective,
    MaskDirective,
    PhoneMaskDirective,
    ServicoObservacoesFormatDirective,
    TypeWriteDirective,
    UppercaseDirective,
    Bg1Directive,
    Bg2Directive
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
